import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/totalVisitsSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { FILTER_OPTIONS } from "../constants";

export const CrossClubFilter = () => {
  const dispatch = useDispatch();

  const selectedCrossClubOptions = useSelector(
    (state) => state.totalVisits.selectedFilters.cross_club
  );

  return (
    <MultiSelectDropdown
      options={FILTER_OPTIONS.crossClub}
      selectedFilters={selectedCrossClubOptions}
      includeFilter={false}
      numberDisplayed={0}
      onSelectChange={(data) => dispatch(actionCreators.updateFilters({ cross_club: data }))}
    />
  );
};
